import { colors } from "@hubrise/react-components"
import styled from "styled-components"

import { Toggle } from "../Styles"

export const StyledCollapsed = styled.div`
  position: relative;
  cursor: pointer;

  ${Toggle} {
    display: none;
  }

  :hover {
    background-color: ${colors.backgroundLightest};

    ${Toggle} {
      display: block;
    }
  }
`

export const OptionLists = styled.div`
  padding: 1rem;
  line-height: 1.5;
`

export const OptionList = styled.div`
  display: inline;
  margin-right: 0.5rem;
  :after {
    content: ".";
  }
`
